import { DEFAULT_LANDING_VIDEO } from "@/constants/campaignBuilder";

/** Whether the landing Video toggle has a video to play: a custom link, else the hosted default
 *  (the same fallback GiftVideoModal resolves). False only when neither exists. */
export function hasLandingVideo(
  videoUrl: string,
  fallback: string = DEFAULT_LANDING_VIDEO,
): boolean {
  return (videoUrl.trim() || fallback).trim() !== "";
}
